module.exports = __webpack_public_path__ + "static/media/1000972.725dc3b1.png";